var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8097 20.266H21.3571V9.38601C21.3571 8.52164 20.6987 7.82636 19.8802 7.82636C19.0616 7.82636 18.4032 8.52164 18.4032 9.38601L18.2608 23.4792H29.792C30.6283 23.4792 31.3045 22.7464 31.3045 21.882C31.3223 20.9988 30.6461 20.266 29.8097 20.266Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 36.6682C29.2051 36.6682 36.6674 29.206 36.6674 20.0009C36.6674 10.7957 29.2051 3.33348 20 3.33348C10.7949 3.33348 3.33262 10.7957 3.33262 20.0009C3.33262 29.206 10.7949 36.6682 20 36.6682ZM20 40.0017C31.0462 40.0017 40.0009 31.047 40.0009 20.0009C40.0009 8.95469 31.0462 0 20 0C8.95383 0 -0.000854492 8.95469 -0.000854492 20.0009C-0.000854492 31.047 8.95383 40.0017 20 40.0017Z",
    fill: "black"
  })));
};
export default SvgClock;